import React from 'react'
import { component_tool } from '@/tool'
import { WizClassifySelect, WizClassifySelectRe } from '@/containers/common';
import LookContentLabel from './lookContentLabel'
//配置项
let componentName = 'contentLabel'
let ref;

const columns = (data) => {
  const { type } = data
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      name: "type",
      formItem: {
        type: "hidden",
      }
    },
    {
      name: "typeInfos",
      formItem: {
        type: "hidden",
      }
    },

    {
      name: "createBy",
      formItem: {
        type: "hidden",
      }
    },
    {
      name: "createTime",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: "标签名称",
      name: "title",
      dataIndex: "title",
      formItem: {
        maxlength: 10,
        placeholder: '标签名称最多输入10个字',
        rules: [
          {
            required: true,
            message: '请输入标签名称'
          },
          {
            pattern: /^[^\s]*$/,
            message: '标签名称录入信息不能包含空格'
          }
        ],
      },
      searchItem: {},
      tableItem: {}
    },
    {
      title: "标签分类",
      name: "typeIds",
      dataIndex: "typeIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {

          itemProps: {
            icon: 'unordered-list',
            title: '标签分类',
            tips: '请勾选所属标签分类'
          },
          treeProps: { checkStrictly: true }
        },
        apiProps: { type },
        selectProps: {
          placeholder: '请选择标签分类'
        },
      },

      formItem: {
        type: 'diy',

        diy: WizClassifySelectRe,
        returnKey: true,
        wizTreeSelectListProps: {
          checkable: false,
          itemProps: {
            icon: 'unordered-list',
            title: '标签分类',
            tips: '请勾选所属标签分类'
          },
          treeProps: { checkStrictly: true }
        },
        apiProps: { type },
        selectProps: {
          placeholder: '请选择标签分类'
        },
        links: ['typeInfos'],
        changePopsFunction: (
          linksValues
        ) => {
          const { typeInfos } = linksValues
          let initSelects = []
          if (typeInfos && typeInfos instanceof Array && typeInfos.length > 0) {
            typeInfos.forEach(element => {
              initSelects.push(element)
            });

          }
          //return { initSelects:initSelects }
          return { initSelects: initSelects }
        },
        initSelects: [],
        //onClearWiz: this._onClearWiz.bind(this),
        rules: [
          { required: true, message: '请选择标签分类', type: 'array' },
        ],

      },
    },
    {
      title: "分类名称",
      name: "categoryName",
      dataIndex: "categoryName",
      tableItem: {}
    },
    {
      title: "顺序",
      name: "orderNo",
      dataIndex: "orderNo",
      tableItem: {},
      formItem: {
        type: 'number',
        // initialValue: data.orderNo,
        rules: [{
          required: true,
          message: '请输入顺序',
        }],
      }
    },
    {
      title: "标签热度值",
      name: "hotValue",
      dataIndex: "hotValue",
      tableItem: {
        type: 'number',
        // initialValue: data.hotValue,
        rules: [{
          required: true,
          message: '请输入标签热度值',
        }],
      },
      formItem: {
        type: 'number',
      }
    },
    {
      title: "标签说明",
      name: "intro",
      dataIndex: "intro",
      formItem: {
        type: 'textarea',
        placeholder: '请输入标签说明,最多100字',
        maxlength: 100,
        rules: [
        ],
      },
    },
  ]
}
  ;

const templateConfig = (data) => {
  //   const { type, pathname } = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        searchBarProps: {
          buttonSort: ['add', 'delete', 'export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: { }
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          collapse: false
        },
        siderBarProps: {
          key: "nodeTree",
          searchKey: "typeIds",
          params: { type: 6 }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['look', 'update'],
        commonOperate: {
          add: true,
          update: true,
          delete: true,
          look: false
        },
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "questionTypeLook",
                modalParams: {
                  title: "查看",
                  cancelButtonProps: { style: { height: 0, width: 0 } },
                  style: { minWidth: 700 },
                  footer: null,
                  diy: (e) => {
                    return (
                      <LookContentLabel
                        key={'questionTypeLook' + e.record.id}
                        {...e}
                        ref={r => {
                          ref = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  onOk: () => {
                    ref._ok();
                  },
                  width: 600
                },
              }
            }
          },
        ]
      }
    }
  }
};



let reduxTemplateCofig = (args) => {
  const { type } = args;
  const apis = {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, type }
      }
    },
    treeData: {
      path: `${componentName}/nodeList`,
      payload: {
        key: `${componentName}@treeData`,
        apiParams: { type }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { type }
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: { type }
      }
    },
    update: {
      path: `${componentName}/upd`,
      payload: {
        key: `${componentName}@upd`,
        apiParams: { type }
      }
    },
    delete: {
      path: `${componentName}/del`,
      payload: {
        key: `${componentName}@del`,
        apiParams: { type }
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    }
  };
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
